// extracted by mini-css-extract-plugin
module.exports = {"sentence":"Sentence_sentence__2EqTb","data":"Sentence_data__45Th7"};